import { ACTIONS } from '../actions/profile'
import { ACTIONS as ACTIONS_DASHBOARD } from '../actions/dashboard'

export const initialState = {
    appState: {
        profileLoaded: false,
        overallWellbeingScoreLoading: false,
        overallWellbeingScoreError: null,
    },
    database: {
        allProfiles: [],
        overallWellbeingScore: [],
        userProfile: {
            givenName: '...',
            totalBudget: 0,
            locale: {},
        },
    },
}

export default (state = initialState, action) => {
    const { database, appState } = state
    let newDatabase = { ...database }
    let newAppState = { ...appState }

    switch (action.type) {
        case ACTIONS_DASHBOARD.GET_DASHBOARD:
            if (!action.data.userProfile) return state
            newDatabase.userProfile = action.data.userProfile
            return {
                ...state,
                database: { ...newDatabase },
            }
        case ACTIONS.GET_PROFILE.START:
            newAppState.profileLoaded = false
            return {
                ...state,
                appState: newAppState,
            }
        case ACTIONS.GET_PROFILE.SUCCESS:
            if (!action.data.userProfile) return state
            newDatabase = { ...newDatabase, ...action.data }
            return {
                ...state,
                appState: { ...appState, profileLoaded: true },
                database: { ...newDatabase },
            }
        case ACTIONS.GET_PROFILE.FAILURE:
            if (!action.data.userProfile) return state
            newDatabase = { ...newDatabase, ...action.data }
            return {
                ...state,
                appState: { ...appState, profileLoaded: false },
                database: { ...newDatabase },
            }

        case ACTIONS.POST_PROFILE.START:
            return {
                ...state,
                appState: { ...appState, postProfileLoading: true },
            }
        case ACTIONS.POST_PROFILE.SUCCESS:
            return {
                ...state,
                appState: { ...appState, postProfileLoading: false, postProfileError: null },
                database: {
                    ...database,
                    userProfile: {
                        ...database.userProfile,
                        ...action.data,
                    },
                },
            }
        case ACTIONS.POST_PROFILE.FAILURE:
            return {
                ...state,
                appState: { ...appState, postProfileLoading: false, postProfileError: action.error },
            }

        case ACTIONS.STORE_PROFILE:
            return {
                ...state,
                database: {
                    userProfile: {
                        ...database.userProfile,
                        ...action.data,
                    },
                },
            }

        case ACTIONS.GET_OVERALL_WELLBEING_SCORES.START:
            return {
                ...state,
                appState: { ...appState, overallWellbeingScoreLoading: true },
            }
        case ACTIONS.GET_OVERALL_WELLBEING_SCORES.SUCCESS:
            return {
                ...state,
                appState: { ...appState, overallWellbeingScoreError: null, overallWellbeingScoreLoading: false },
                database: { ...database, overallWellbeingScore: action.data },
            }
        case ACTIONS.GET_OVERALL_WELLBEING_SCORES.FAILURE:
            return {
                ...state,
                appState: { ...appState, overallWellbeingScoreError: action.error, overallWellbeingScoreLoading: false },
                database: { ...database, overallWellbeingScore: [] },
            }

        default:
            return state
    }
}
